import { locationSelectedAriaLabel } from './getLocationResultAriaLabel.locstring.json';
import { unknownFreeBusy } from 'owa-locstrings/lib/strings/unknownfreebusy.locstring.json';
import { availableFreeBusy } from 'owa-locstrings/lib/strings/availablefreebusy.locstring.json';
import { showAsBusy } from 'owa-locstrings/lib/strings/showasbusy.locstring.json';
import loc, { format } from 'owa-localize';

import { LocationPersonaControlViewState } from 'owa-location-persona';
import shouldRenderCity from 'owa-location-common-well/lib/utils/shouldRenderCity';

export default function getLocationResultAriaLabel(
    location: LocationPersonaControlViewState,
    roomFreeBusyEnabled: boolean
): string {
    let isRoomWithAvailabilityInfo = location.personaType == 'Room' && roomFreeBusyEnabled;
    let secondaryData: string = location.displayAddress;

    if (isRoomWithAvailabilityInfo) {
        let freebusyText = loc(unknownFreeBusy);

        if (location.availability) {
            switch (location.availability) {
                case 'Free':
                    freebusyText = loc(availableFreeBusy);
                    break;
                case 'Busy':
                    freebusyText = loc(showAsBusy);
                    break;
            }
        }

        if (shouldRenderCity(location)) {
            secondaryData = format('{0}, {1}', freebusyText, location.postalAddress.City);
        } else {
            secondaryData = freebusyText;
        }
    }

    return format(loc(locationSelectedAriaLabel), location.displayName, secondaryData);
}
